import { d, y, u, A, $, k, r as register, x } from "./preact-core.js";
import { u as useStorefrontClient } from "./shopifyStorefront.js";
import { l as layout } from "./layout-store.js";
import { p as parseRichText } from "./richTextParser.js";
import { E } from "./preact-signals.js";
import "./graphql-client.js";
const _gql_source = `query GetExperiences($first: Int!, $after: String) {
  metaobjects(type: "experiences", first: $first, after: $after) {
    edges {
      node {
        id
        handle
        title: field(key: "title") { value }
        brand: field(key: "brand") { value }
        image: field(key: "image") {
          reference {
            ... on MediaImage {
              image {
                url
                altText
                width
                height
              }
            }
          }
        }
        short_description: field(key: "short_description") { value }
        description: field(key: "description") { value }
        pricing: field(key: "pricing") { value }
        group_size: field(key: "group_size") { value }
        duration: field(key: "duration") { value }
        location: field(key: "location") { value }
        when: field(key: "when") { value }
        tock_reservation_id: field(key: "tock_reservation_id") { value }
        event_url: field(key: "event_url") { value }
        booking_button_text: field(key: "booking_button_text") { value }
        order: field(key: "order") { value }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
`;
const _gql_doc = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetExperiences" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "first" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } }, "directives": [] }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "after" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } }, "directives": [] }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "metaobjects" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "type" }, "value": { "kind": "StringValue", "value": "experiences", "block": false } }, { "kind": "Argument", "name": { "kind": "Name", "value": "first" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "first" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "after" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "after" } } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "edges" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "node" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" }, "arguments": [], "directives": [] }, { "kind": "Field", "name": { "kind": "Name", "value": "handle" }, "arguments": [], "directives": [] }, { "kind": "Field", "alias": { "kind": "Name", "value": "title" }, "name": { "kind": "Name", "value": "field" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "StringValue", "value": "title", "block": false } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "value" }, "arguments": [], "directives": [] }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "brand" }, "name": { "kind": "Name", "value": "field" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "StringValue", "value": "brand", "block": false } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "value" }, "arguments": [], "directives": [] }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "image" }, "name": { "kind": "Name", "value": "field" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "StringValue", "value": "image", "block": false } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "reference" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "MediaImage" } }, "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "image" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "url" }, "arguments": [], "directives": [] }, { "kind": "Field", "name": { "kind": "Name", "value": "altText" }, "arguments": [], "directives": [] }, { "kind": "Field", "name": { "kind": "Name", "value": "width" }, "arguments": [], "directives": [] }, { "kind": "Field", "name": { "kind": "Name", "value": "height" }, "arguments": [], "directives": [] }] } }] } }] } }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "short_description" }, "name": { "kind": "Name", "value": "field" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "StringValue", "value": "short_description", "block": false } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "value" }, "arguments": [], "directives": [] }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "description" }, "name": { "kind": "Name", "value": "field" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "StringValue", "value": "description", "block": false } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "value" }, "arguments": [], "directives": [] }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "pricing" }, "name": { "kind": "Name", "value": "field" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "StringValue", "value": "pricing", "block": false } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "value" }, "arguments": [], "directives": [] }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "group_size" }, "name": { "kind": "Name", "value": "field" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "StringValue", "value": "group_size", "block": false } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "value" }, "arguments": [], "directives": [] }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "duration" }, "name": { "kind": "Name", "value": "field" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "StringValue", "value": "duration", "block": false } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "value" }, "arguments": [], "directives": [] }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "location" }, "name": { "kind": "Name", "value": "field" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "StringValue", "value": "location", "block": false } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "value" }, "arguments": [], "directives": [] }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "when" }, "name": { "kind": "Name", "value": "field" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "StringValue", "value": "when", "block": false } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "value" }, "arguments": [], "directives": [] }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "tock_reservation_id" }, "name": { "kind": "Name", "value": "field" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "StringValue", "value": "tock_reservation_id", "block": false } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "value" }, "arguments": [], "directives": [] }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "event_url" }, "name": { "kind": "Name", "value": "field" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "StringValue", "value": "event_url", "block": false } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "value" }, "arguments": [], "directives": [] }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "booking_button_text" }, "name": { "kind": "Name", "value": "field" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "StringValue", "value": "booking_button_text", "block": false } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "value" }, "arguments": [], "directives": [] }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "order" }, "name": { "kind": "Name", "value": "field" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "StringValue", "value": "order", "block": false } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "value" }, "arguments": [], "directives": [] }] } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "pageInfo" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "hasNextPage" }, "arguments": [], "directives": [] }, { "kind": "Field", "name": { "kind": "Name", "value": "endCursor" }, "arguments": [], "directives": [] }] } }] } }] } }], "loc": { "start": 0, "end": 1247, "source": { "name": "GraphQL request", "locationOffset": { "line": 1, "column": 1 }, "body": _gql_source } } };
function handleize(str) {
  return str.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
}
function getExperienceId(experience) {
  var _a;
  const titleHandle = handleize(((_a = experience.title) == null ? void 0 : _a.value) || "");
  const gid = experience.id || "";
  const systemId = gid.split("/").pop() || gid;
  return `${titleHandle}-${systemId}`;
}
function todayISO() {
  const now = /* @__PURE__ */ new Date();
  const month = `${now.getMonth() + 1}`.padStart(2, "0");
  const day = `${now.getDate()}`.padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
}
function isPastEvent(experience) {
  var _a;
  const whenValue = (_a = experience.when) == null ? void 0 : _a.value;
  if (!whenValue) return false;
  return whenValue.slice(0, 10) < todayISO();
}
function formatEventDate(whenValue) {
  return new Date(whenValue.slice(0, 10)).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC"
  });
}
function filterAndSortExperiences(experiences, show = "all") {
  const active = experiences.filter((exp) => !isPastEvent(exp));
  const dated = show === "undated" ? [] : active.filter((exp) => {
    var _a;
    return (_a = exp.when) == null ? void 0 : _a.value;
  });
  const undated = show === "dated" ? [] : active.filter((exp) => {
    var _a;
    return !((_a = exp.when) == null ? void 0 : _a.value);
  });
  dated.sort((a, b) => {
    const dateA = new Date(a.when.value).getTime();
    const dateB = new Date(b.when.value).getTime();
    return dateA - dateB;
  });
  undated.sort((a, b) => {
    var _a, _b;
    const orderA = ((_a = a.order) == null ? void 0 : _a.value) ? parseInt(a.order.value, 10) : Infinity;
    const orderB = ((_b = b.order) == null ? void 0 : _b.value) ? parseInt(b.order.value, 10) : Infinity;
    return orderA - orderB;
  });
  return [...undated, ...dated];
}
const SHOW_MODES = ["all", "dated", "undated"];
function useExperiences(brand, handles, show) {
  const [experiences, setExperiences] = d([]);
  const [loading, setLoading] = d(true);
  const [error, setError] = d(null);
  const client = useStorefrontClient();
  y(() => {
    setLoading(true);
    setError(null);
    setExperiences([]);
    if (!brand && !handles) {
      setLoading(false);
      setError("No brand or handles provided");
      return;
    }
    const fetchExperiences = async () => {
      var _a;
      try {
        let allNodes = [];
        let hasNextPage = true;
        let after = null;
        while (hasNextPage) {
          const data = await client.request(
            _gql_doc,
            { first: 100, after }
          );
          if (!((_a = data == null ? void 0 : data.metaobjects) == null ? void 0 : _a.edges)) {
            throw new Error("Unexpected data structure from GraphQL response");
          }
          const pageNodes = data.metaobjects.edges.map((edge) => edge.node).filter((node) => node == null ? void 0 : node.id);
          allNodes = [...allNodes, ...pageNodes];
          hasNextPage = data.metaobjects.pageInfo.hasNextPage;
          after = data.metaobjects.pageInfo.endCursor;
        }
        if (handles) {
          const handleList = handles.split(",").map((h) => h.trim());
          const matched = allNodes.filter(
            (n) => handleList.includes(n.handle)
          );
          matched.sort(
            (a, b) => handleList.indexOf(a.handle) - handleList.indexOf(b.handle)
          );
          setExperiences(matched);
        } else {
          const brandFiltered = allNodes.filter(
            (node) => {
              var _a2;
              return ((_a2 = node.brand) == null ? void 0 : _a2.value) === brand;
            }
          );
          const showMode = SHOW_MODES.includes(show) ? show : "all";
          const sorted = filterAndSortExperiences(brandFiltered, showMode);
          setExperiences(sorted);
        }
        setLoading(false);
      } catch (err) {
        console.error("Error fetching experiences:", err);
        setError(err instanceof Error ? err.message : "Unknown error");
        setLoading(false);
      }
    };
    fetchExperiences();
  }, [brand, handles, show, client]);
  return { experiences, loading, error };
}
function EventCard({ experience, headingType }) {
  var _a, _b, _c, _d, _e, _f, _g;
  const headingEl = headingType === "h1" ? "h2" : headingType === "h2" ? "h3" : "h4";
  const HeadingTag = headingEl;
  const experienceId = getExperienceId(experience);
  const imageRef = (_b = (_a = experience.image) == null ? void 0 : _a.reference) == null ? void 0 : _b.image;
  const whenValue = (_c = experience.when) == null ? void 0 : _c.value;
  const handleLearnMore = () => {
    layout.slideover.value = experienceId;
  };
  return /* @__PURE__ */ u("div", { class: "grid gap-30 border-b-1 py-30 sm:grid-cols-[200px_1fr] md:grid-cols-[290px_1fr]", children: [
    /* @__PURE__ */ u("div", { class: "relative aspect-[435/290] w-full", children: imageRef && /* @__PURE__ */ u(
      "img",
      {
        src: imageRef.url,
        alt: imageRef.altText || ((_d = experience.title) == null ? void 0 : _d.value) || "",
        width: imageRef.width,
        height: imageRef.height,
        class: "u--cover-img",
        loading: "lazy"
      }
    ) }),
    /* @__PURE__ */ u("div", { class: "flex w-full flex-wrap justify-between gap-20 md:flex-nowrap", children: [
      /* @__PURE__ */ u("div", { class: "description shrink", children: [
        /* @__PURE__ */ u(HeadingTag, { class: "h5 mb-20", children: (_e = experience.title) == null ? void 0 : _e.value }),
        whenValue && /* @__PURE__ */ u("time", { class: "block leading-lh-60 max-w-420", dateTime: whenValue, children: formatEventDate(whenValue) }),
        /* @__PURE__ */ u("div", { class: "leading-lh-60 mb-20 max-w-420", children: (_f = experience.pricing) == null ? void 0 : _f.value }),
        /* @__PURE__ */ u("div", { class: "leading-lh-60 max-w-420", children: (_g = experience.short_description) == null ? void 0 : _g.value })
      ] }),
      /* @__PURE__ */ u("div", { class: "md:ml-auto", children: /* @__PURE__ */ u(
        "button",
        {
          type: "button",
          class: "btn btn--outline --gold",
          onClick: handleLearnMore,
          children: "Learn More"
        }
      ) })
    ] })
  ] });
}
function ExperienceSlideover({
  experiences
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const experienceIds = experiences.map(getExperienceId);
  const [activeId, setActiveId] = d(
    layout.slideover.value
  );
  y(() => {
    return E(() => {
      setActiveId(layout.slideover.value);
    });
  }, []);
  const isOpen = activeId != null && experienceIds.includes(activeId);
  const activeExperience = isOpen ? experiences.find((exp) => getExperienceId(exp) === activeId) : null;
  const lastExperienceRef = A(null);
  if (activeExperience) {
    lastExperienceRef.current = activeExperience;
  }
  const displayExperience = activeExperience || lastExperienceRef.current;
  const close = () => {
    layout.slideover.value = null;
  };
  y(() => {
    if (isOpen) {
      document.body.classList.add("slideover-open");
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.classList.remove("slideover-open");
      document.documentElement.style.overflow = "";
    }
  }, [isOpen]);
  y(() => {
    const handleKeyup = (e) => {
      if (e.code === "Escape" && isOpen) close();
    };
    document.addEventListener("keyup", handleKeyup);
    return () => document.removeEventListener("keyup", handleKeyup);
  }, [isOpen]);
  const brandSlug = ((_a = displayExperience == null ? void 0 : displayExperience.brand) == null ? void 0 : _a.value) === "Cuvaison" ? "cuvaison" : "brandlin";
  const bookingText = ((_b = displayExperience == null ? void 0 : displayExperience.booking_button_text) == null ? void 0 : _b.value) || "Book Now";
  return $(
    /* @__PURE__ */ u(
      "aside",
      {
        class: `slideover slideover--right ${isOpen ? "active" : ""}`,
        children: [
          /* @__PURE__ */ u("div", { class: "slideover__panel bg-background", children: [
            /* @__PURE__ */ u(
              "button",
              {
                type: "button",
                class: "close general-hover z-30 tracking-button text-small",
                onClick: close,
                children: "Close"
              }
            ),
            /* @__PURE__ */ u("div", { class: "slideover__content-wrap", children: [
              /* @__PURE__ */ u("div", { class: "py-10 border-b-1 background min-h-47 flex items-center px-40" }),
              displayExperience && /* @__PURE__ */ u("div", { class: "bg-background p-40", children: /* @__PURE__ */ u("div", { class: "slideover__content pb-100", children: [
                /* @__PURE__ */ u("h2", { class: "mb-30", children: (_c = displayExperience.title) == null ? void 0 : _c.value }),
                /* @__PURE__ */ u("dl", { class: "mb-30 max-w-415 leading-lh-60", children: [
                  ((_d = displayExperience.pricing) == null ? void 0 : _d.value) && /* @__PURE__ */ u(k, { children: [
                    /* @__PURE__ */ u("dt", { class: "font-medium", children: "Price:" }),
                    /* @__PURE__ */ u("dd", { children: displayExperience.pricing.value })
                  ] }),
                  ((_e = displayExperience.group_size) == null ? void 0 : _e.value) && /* @__PURE__ */ u(k, { children: [
                    /* @__PURE__ */ u("dt", { class: "font-medium", children: "Group Size:" }),
                    /* @__PURE__ */ u("dd", { children: displayExperience.group_size.value })
                  ] }),
                  ((_f = displayExperience.duration) == null ? void 0 : _f.value) && /* @__PURE__ */ u(k, { children: [
                    /* @__PURE__ */ u("dt", { class: "font-medium", children: "Duration:" }),
                    /* @__PURE__ */ u("dd", { children: displayExperience.duration.value })
                  ] }),
                  ((_g = displayExperience.location) == null ? void 0 : _g.value) && /* @__PURE__ */ u(k, { children: [
                    /* @__PURE__ */ u("dt", { class: "font-medium", children: "Location:" }),
                    /* @__PURE__ */ u("dd", { children: displayExperience.location.value })
                  ] })
                ] }),
                ((_h = displayExperience.tock_reservation_id) == null ? void 0 : _h.value) ? /* @__PURE__ */ u(
                  "a",
                  {
                    href: `https://www.exploretock.com/${brandSlug}`,
                    class: "btn btn--outline --gold mb-30",
                    "data-tock-reserve": "true",
                    "data-tock-experience": displayExperience.tock_reservation_id.value,
                    children: "Book Now"
                  }
                ) : ((_i = displayExperience.event_url) == null ? void 0 : _i.value) ? /* @__PURE__ */ u(
                  "a",
                  {
                    href: displayExperience.event_url.value,
                    class: "btn btn--outline --gold mb-30",
                    children: bookingText
                  }
                ) : null,
                ((_j = displayExperience.description) == null ? void 0 : _j.value) && /* @__PURE__ */ u(
                  "div",
                  {
                    class: "rte-content leading-60-lh mb-30",
                    dangerouslySetInnerHTML: {
                      __html: parseRichText(
                        displayExperience.description.value
                      )
                    }
                  }
                )
              ] }) })
            ] })
          ] }),
          /* @__PURE__ */ u("div", { class: "__backdrop", onClick: close })
        ]
      }
    ),
    document.body
  );
}
function EventDirectoryProvider({
  brand,
  headingType,
  handles,
  show
}) {
  const { experiences, loading, error } = useExperiences(brand, handles, show);
  return /* @__PURE__ */ u("div", { class: "event-directory", children: [
    loading && /* @__PURE__ */ u("div", { class: "loader" }),
    !loading && !error && experiences.length > 0 && /* @__PURE__ */ u(k, { children: [
      /* @__PURE__ */ u("div", { class: "events", children: experiences.map((exp) => /* @__PURE__ */ u(
        EventCard,
        {
          experience: exp,
          headingType
        },
        exp.id
      )) }),
      /* @__PURE__ */ u(ExperienceSlideover, { experiences })
    ] }),
    !loading && !error && experiences.length === 0 && /* @__PURE__ */ u("div", { children: "No experiences found." }),
    !loading && error && /* @__PURE__ */ u("div", { class: "error", children: [
      "Error loading experiences: ",
      error
    ] })
  ] });
}
class EventDirectory extends x {
  render() {
    const { brand, handles, show } = this.props;
    const headingType = this.props["heading-type"];
    return /* @__PURE__ */ u(
      EventDirectoryProvider,
      {
        brand,
        headingType,
        handles,
        show
      }
    );
  }
}
const EventDirectory$1 = () => {
  register(EventDirectory, "event-directory", [
    "brand",
    "heading-type",
    "handles",
    "show"
  ]);
};
EventDirectory$1();
